import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import authService from './authService';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // Get base URL from env
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to attach the JWT token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      sessionStorage.setItem('sessionExpired', 'true');
      const currentPath = window.location.pathname + window.location.search;
      window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
      return Promise.reject(new Error('Token not found'));
    } // Get token from localStorage
    config.headers['Authorization'] = `Bearer ${token}`; // Add Authorization header
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Optional: Add a response interceptor to handle token expiration or errors globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Show session expired notification
      // enqueueSnackbar('Session expired. Please login again.', {
      //   variant: 'warning',
      //   autoHideDuration: 5000,
      // });

      // Logout user with session expired flag
      sessionStorage.setItem('sessionExpired', 'true');
      authService.logout(true);
      return;
    }
    return Promise.reject(error);
  }
);

// Public Axios instance (for APIs that don't require authentication)
const publicAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

export { axiosInstance, publicAxiosInstance };